exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "a[data-v-5b459b8a] {\n  display: block;\n  cursor: pointer;\n}\n.simpleLanguageSwitcher[data-v-5b459b8a] {\n  padding: 0 4rem;\n}\n.simpleLanguageSwitcher a[data-v-5b459b8a] {\n    font-size: 1rem;\n}\n", ""]);

